import { render, staticRenderFns } from "./reportProficientCarFee.vue?vue&type=template&id=0c4e9ad2&scoped=true"
import script from "./reportProficientCarFee.vue?vue&type=script&lang=js"
export * from "./reportProficientCarFee.vue?vue&type=script&lang=js"
import style0 from "./reportProficientCarFee.vue?vue&type=style&index=0&id=0c4e9ad2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4e9ad2",
  null
  
)

export default component.exports